export { default } from "./thankYouCard";
